import DashboardIcon from "@material-ui/icons/Dashboard";

import SimuladorCativo from "views/Pages/SimuladoresPage.jsx";

const dashRoutes = [
  {
    path: "/area-aberta/simulador-cativo-livre",
    name: "Simulador Cativo",
    icon: DashboardIcon,
    component: SimuladorCativo,
  },
];

export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboardAreaAberta.jsx